"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var index_1 = __importDefault(require("./content/index"));
var index_2 = __importDefault(require("../../landing/fans/sections/getStarted/index"));
var semantic_ui_react_1 = require("semantic-ui-react");
var index_module_scss_1 = __importDefault(require("./index.module.scss"));
var i18next_1 = require("i18next");
function CollectibleEvents() {
    var pages = ["health"];
    var param = window.location.pathname.split("/")[2];
    var pageCheck = pages.find(function (x) { return x === param; });
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(semantic_ui_react_1.Grid, __assign({ columns: 1 }, { children: (0, jsx_runtime_1.jsxs)("div", __assign({ className: index_module_scss_1.default.hero }, { children: [(0, jsx_runtime_1.jsx)("div", { className: index_module_scss_1.default.overlay }), (0, jsx_runtime_1.jsx)(semantic_ui_react_1.Container, { children: (0, jsx_runtime_1.jsx)("div", __assign({ className: index_module_scss_1.default.heading }, { children: (0, jsx_runtime_1.jsx)(semantic_ui_react_1.Grid.Column, { children: (0, jsx_runtime_1.jsx)("h3", { dangerouslySetInnerHTML: { __html: (0, i18next_1.t)("collectibleFitness.title") } }) }) })) })] })) })), (0, jsx_runtime_1.jsx)(index_1.default, {}), (0, jsx_runtime_1.jsx)(index_2.default, {})] }));
}
exports.default = CollectibleEvents;
